export const CustomerPlacement = {
  BACK_ORDER: 'backOrder',
  PRE_SALE: 'preSale',
  STANDARD: 'standard'
}

export const BACK_ORDER_MAX_ITEMS = 12;

export const getDeliveryType = (type) => {
  switch (type) {
    case 'onDemand':
    case 'on_demand':
      return { color: 'bg-emerald-500', label: 'On Demand' };
    case 'shipping':
      return { color: 'bg-gray-500', label: 'Standard Shipping' };
    case 'engraved':
      return { color: 'bg-gray-500', label: 'Standard Shipping' };
    default:
      return {};
  }
}

export const getCartDeliveryExpectationTitle = ({deliveryType, customerPlacement}) => {
  switch (customerPlacement) {
    case CustomerPlacement.BACK_ORDER:
      return 'Backorders';
    case CustomerPlacement.PRE_SALE:
      return 'Preorders';
    default:
      break;
  }

  switch (deliveryType) {
    case 'onDemand':
    case 'on_demand':
      return 'Same Day Delivery';
    case 'shipped':
    case 'shipping':
    case 'engraved':
      return 'Shipping';
    default:
      return '';
  }
}

function mapCustomerPlacement(customerPlacement) {
  switch (customerPlacement) {
    case 'backOrder':
      return CustomerPlacement.BACK_ORDER;
    case 'preOrder':
      return CustomerPlacement.PRE_ORDER;
    case 'preSale':
      return CustomerPlacement.PRE_SALE;
    default:
      return customerPlacement;
  }
}

function mapDeliveryType(deliveryType) {
  return deliveryType === 'onDemand'
    ? 'on_demand'
    : deliveryType;
}

export const isPreSaleItem = (item) => CustomerPlacement.PRE_SALE === item.customerPlacement;

export const liquidProduct = async (client, info) => new Promise(resolve => {
  const data = {
    status: 0,
    product: {}
  }
  try {
    if (info.ids.length > 0) {
      client.product(info)
        .then((products) => {
          products.forEach(product => {
            product.sizes = product.variants.map((variant, index) => {
              variant.retailers?.forEach(retailer => {
                retailer.customerPlacement = mapCustomerPlacement(retailer.customerPlacement);
                retailer.inStock = retailer.customerPlacement === CustomerPlacement.BACK_ORDER ? BACK_ORDER_MAX_ITEMS : retailer.inStock;
                retailer.deliveryType = mapDeliveryType(retailer.deliveryType);
              })

              const isBundle = !!product.bundleConfigs;
              const id = isBundle ? product.id : variant.retailers[0].variantId;

              return {
                id,
                isBundle,
                value: id?.toString() || '',
                label: variant.size,
                size: variant.size.split(',')[0],
                type: variant.size.split(',')[1],
                productId: variant.productId,
                disabled: false,
                active: index === 0,
                retailer: variant.retailers[0].retailer.name,
                image: variant.images?.[0],
                price: product.price || variant.retailers[0].price,
                deliveryExpectation: variant.retailers[0].shippingMethod.shortDeliveryExpectation,
                shipping: getDeliveryType(variant.retailers[0].type)?.label,
                inStock: variant.retailers[0].inStock,
                hasEngraving: variant.retailers.some(retailer => retailer.type === 'engraved'),
                retailers: variant.retailers,
                engravingConfigs: variant.engravingConfigs,
                preSale: variant.presale,
                name: variant.name,
              }
            });
          })

          resolve({
            status: 1,
            products
          })
        })
        .catch(e => console.error(e) && resolve(data))
    } else resolve(data);
  } catch (e) {
    console.error(e);
    resolve(data)
  }
})
